// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * MSSQL数据类型枚举 枚举类
 * MSSQL数据类型枚举
 */
export enum EnumMSSQLDataType {
  /** 单字节整数 : 单字节整数，1个字节 */
  Tinyint = 1,
  /** 短整数 : 双字节整数，2个字节 */
  Smallint = 2,
  /** 整数 : 整数，四个字节 */
  Int = 4,
  /** 长整数 : 长整数，八个字节 */
  Bigint = 8,
  /** 定长字符串 : 定长字符串，不含Unicode字符，最大长度8000 */
  Char = 16,
  /** 定长Unicode字符串 : 定长字符串，包含Unicode字符，最大长度4000 */
  NChar = 32,
  /** 变长字符串 : 变长字符串，不含Unicode字符，最大长度8000 */
  Varchar = 64,
  /** 变长Unicode字符串 : 变长Unicode字符串，包含Unicode字符，最大长度4000 */
  NVarchar = 128,
  /** 长文本 : 可变长度长文本，不含Unicode字符，最长2的31次方减1 */
  Text = 256,
  /** Unicode长文本 : 可变长度长文本，包含Unicode字符，最长2的30次方减1 */
  NText = 512,
  /** 小数 : 小数，具体由精度和小数位决定 */
  Decimal = 1024,
  /** 布尔型 : 使用1个bit位 */
  Bit = 2048,
  /** 日期时间型 : 日期时间型，最小日期为1753-01-01 */
  DateTime = 4096
}

/**
 * MSSQL数据类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumMSSQLDataTypeMD {
  private static items = [
    new EnumItemMD('Tinyint', 1, '单字节整数', '单字节整数，1个字节'),
    new EnumItemMD('Smallint', 2, '短整数', '双字节整数，2个字节'),
    new EnumItemMD('Int', 4, '整数', '整数，四个字节'),
    new EnumItemMD('Bigint', 8, '长整数', '长整数，八个字节'),
    new EnumItemMD('Char', 16, '定长字符串', '定长字符串，不含Unicode字符，最大长度8000'),
    new EnumItemMD('NChar', 32, '定长Unicode字符串', '定长字符串，包含Unicode字符，最大长度4000'),
    new EnumItemMD('Varchar', 64, '变长字符串', '变长字符串，不含Unicode字符，最大长度8000'),
    new EnumItemMD('NVarchar', 128, '变长Unicode字符串', '变长Unicode字符串，包含Unicode字符，最大长度4000'),
    new EnumItemMD('Text', 256, '长文本', '可变长度长文本，不含Unicode字符，最长2的31次方减1'),
    new EnumItemMD('NText', 512, 'Unicode长文本', '可变长度长文本，包含Unicode字符，最长2的30次方减1'),
    new EnumItemMD('Decimal', 1024, '小数', '小数，具体由精度和小数位决定'),
    new EnumItemMD('Bit', 2048, '布尔型', '使用1个bit位'),
    new EnumItemMD('DateTime', 4096, '日期时间型', '日期时间型，最小日期为1753-01-01')
  ];

  static getItem(enumItem: EnumMSSQLDataType) {
    return this.items.find(item => item.name === EnumMSSQLDataType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
